"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ContactsSelectors = require("pricing-pages-unified-ui/selectors/ContactsSelectors");

var _ContactsSlider = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ContactsSlider"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PricingSelectors = require("pricing-pages-unified-ui/selectors/PricingSelectors");

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _ContactPriceBreakdownModal = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/contacts-price-breakdown/ContactPriceBreakdownModal"));

var _ContactsMaxLimitContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/info-box/ContactsMaxLimitContainer"));

var _ContactsInfoBox = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/info-box/ContactsInfoBox"));

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _merchandiseUtils = require("pricing-pages-unified-ui/utils/merchandiseUtils");

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _itemConfigUtils = require("self-service-api/core/utilities/itemConfigUtils");

var StyledSliderWrapper = function StyledSliderWrapper(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_ContactsSlider.default, Object.assign({
    numberInputClassName: className
  }, rest));
};

var StyledSlider = (0, _styledComponents.default)(StyledSliderWrapper).withConfig({
  displayName: "ContactsSliderContainer__StyledSlider",
  componentId: "sc-3cmpug-0"
})(["font-size:14px !important;max-width:100px;"]);

var ContactsSliderDescription = function ContactsSliderDescription(_ref2) {
  var baseMerchId = _ref2.baseMerchId,
      term = _ref2.term,
      isCovidPromo = _ref2.isCovidPromo,
      isGrowthSuite = _ref2.isGrowthSuite,
      additionalContacts = _ref2.additionalContacts;
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var termId = (0, _reactRedux.useSelector)(_PricingSelectors.getTermIdSelector)(baseMerchId, term, isGrowthSuite, isCovidPromo);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      priceBreakdownVisible = _useState2[0],
      setPriceBreakdownVisible = _useState2[1];

  var _merchandiseMap$baseM = merchandiseMap[baseMerchId],
      additionalUnitMerchId = _merchandiseMap$baseM.additionalUnitMerchId,
      includedAdditionalUnits = _merchandiseMap$baseM.includedAdditionalUnits;
  var quantityMultiplier = merchandiseMap[additionalUnitMerchId].quantityMultiplier;
  var startingPriceForContacts = (0, _reactRedux.useSelector)(function (state) {
    return (0, _PricingSelectors.calculatedPriceSelector)(state, {
      merchandiseId: baseMerchId,
      itemConfigurations: [(0, _itemConfigUtils.createItemConfigObject)({
        merchandiseId: additionalUnitMerchId
      })],
      termId: termId,
      isCovidPromo: isCovidPromo,
      isGrowthSuite: isGrowthSuite
    });
  }).monthly.calculatedPrice;
  return _react.default.createElement(_react.default.Fragment, null, priceBreakdownVisible && _react.default.createElement(_ContactPriceBreakdownModal.default, {
    merchandiseId: additionalUnitMerchId,
    marketingContactsSelected: additionalContacts + includedAdditionalUnits,
    termId: termId,
    handleModalClose: function handleModalClose() {
      return setPriceBreakdownVisible(false);
    }
  }), _react.default.createElement(_Small.default, {
    className: "flex-column"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "marketingContactsBeta.contactsSlider.description_jsx",
    elements: {
      QuantityMultiplier: function QuantityMultiplier() {
        return _react.default.createElement(_FormattedNumber.default, {
          value: quantityMultiplier
        });
      },
      IncludedAdditionalUnits: function IncludedAdditionalUnits() {
        return _react.default.createElement(_FormattedNumber.default, {
          value: includedAdditionalUnits
        });
      },
      Price: function Price() {
        return _react.default.createElement(_FormattedCurrency.default, {
          value: startingPriceForContacts,
          currencyCode: currencyCode
        });
      },
      Link: function Link(_ref3) {
        var children = _ref3.children;
        return _react.default.createElement(_UILink.default, {
          onClick: function onClick() {
            return setPriceBreakdownVisible(true);
          }
        }, children);
      }
    }
  })));
};

var ContactsSliderContainer = function ContactsSliderContainer(_ref4) {
  var baseMerchId = _ref4.baseMerchId,
      additionalUnitQuantity = _ref4.additionalUnitQuantity,
      _onChange = _ref4.onChange,
      term = _ref4.term,
      setActiveEdition = _ref4.setActiveEdition,
      _ref4$isGrowthSuite = _ref4.isGrowthSuite,
      isGrowthSuite = _ref4$isGrowthSuite === void 0 ? false : _ref4$isGrowthSuite,
      _ref4$isCovidPromo = _ref4.isCovidPromo,
      isCovidPromo = _ref4$isCovidPromo === void 0 ? false : _ref4$isCovidPromo;
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var isMarketingContactsSKU = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.isMarketingContactsSKUSelector)(state, baseMerchId);
  });
  var minPurchasableContacts = (0, _reactRedux.useSelector)(function (state) {
    return (0, _ContactsSelectors.minPurchasableContactsSelector)(state, baseMerchId);
  }) || 0;
  var _merchandiseMap$baseM2 = merchandiseMap[baseMerchId],
      includedAdditionalUnits = _merchandiseMap$baseM2.includedAdditionalUnits,
      maxAdditionalUnits = _merchandiseMap$baseM2.maxAdditionalUnits,
      additionalUnitMerchId = _merchandiseMap$baseM2.additionalUnitMerchId,
      edition = _merchandiseMap$baseM2.edition;
  var quantityMultiplier = merchandiseMap[additionalUnitMerchId].quantityMultiplier;
  var maxContactsInPlan = maxAdditionalUnits - maxAdditionalUnits % quantityMultiplier + (isMarketingContactsSKU ? includedAdditionalUnits : 0);
  var steppingFunction = (0, _merchandiseUtils.getMerchSpecificSteppingFunction)(merchandiseMap, baseMerchId);
  (0, _react.useEffect)(function () {
    if (additionalUnitQuantity < minPurchasableContacts) {
      _onChange(steppingFunction(minPurchasableContacts));
    } else if (steppingFunction(additionalUnitQuantity) !== additionalUnitQuantity) {
      _onChange(steppingFunction(additionalUnitQuantity));
    }
  }, [additionalUnitQuantity, minPurchasableContacts]);

  var handleSwitchToEnterprise = function handleSwitchToEnterprise() {
    setActiveEdition(Editions.ENTERPRISE);

    var enterpriseId = (0, _SuiteEditionMerchIdMap.default)(isMarketingContactsSKU)[Editions.ENTERPRISE][_Hubs.default.HUB_MARKETING];

    var newMarketingUnits = (0, _merchandiseUtils.calculateAdditionalUnitsForTierSwitch)(additionalUnitQuantity, merchandiseMap[baseMerchId], merchandiseMap[enterpriseId]);
    var enterpriseSteppingFunction = (0, _merchandiseUtils.getMerchSpecificSteppingFunction)(merchandiseMap, enterpriseId);

    _onChange(enterpriseSteppingFunction(newMarketingUnits));
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledSlider, {
    value: steppingFunction(additionalUnitQuantity) + includedAdditionalUnits,
    min: includedAdditionalUnits + minPurchasableContacts,
    trackStart: includedAdditionalUnits,
    max: maxContactsInPlan,
    step: quantityMultiplier,
    labelsBelowSlider: true,
    onChange: function onChange(newValue) {
      return _onChange(steppingFunction(newValue - includedAdditionalUnits));
    },
    title: _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "marketingContactsBeta.marketingContacts"
    })),
    description: _react.default.createElement(ContactsSliderDescription, {
      term: term,
      baseMerchId: baseMerchId,
      isGrowthSuite: isGrowthSuite,
      isCovidPromo: isCovidPromo,
      additionalContacts: additionalUnitQuantity
    })
  }), setActiveEdition && edition === Editions.PROFESSIONAL && _react.default.createElement(_ContactsInfoBox.default, {
    titleKey: "pricingPage.calculator.contacts.pricingTip.title",
    content: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.calculator.contacts.pricingTip.marketingProTip_jsx",
      elements: {
        UILink: _UILink.default
      },
      options: {
        onClick: handleSwitchToEnterprise
      }
    }),
    showBox: additionalUnitQuantity + includedAdditionalUnits >= maxContactsInPlan
  }), edition === Editions.ENTERPRISE && _react.default.createElement(_ContactsInfoBox.default, {
    titleKey: "pricingPage.calculator.contacts.upperLimitTip.title",
    content: _react.default.createElement(_ContactsMaxLimitContainer.default, null),
    showBox: additionalUnitQuantity + includedAdditionalUnits === maxContactsInPlan
  }), _react.default.createElement(_UITile.default, {
    className: "p-all-3 m-top-4"
  }, _react.default.createElement(_Small.default, {
    className: "justify-center text-center"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "marketingContactsBeta.contactsSlider.incluesFreeContacts"
  }))));
};

var _default = ContactsSliderContainer;
exports.default = _default;
module.exports = exports.default;